import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import config from '../../constants/config';

const requiredFields = [
   { key: "select", thStyle: { width: '40px' } },
  { key: "view", thStyle: { width: '60px' } }
]

const optionalFields = [
    { key: 'organization.name', label: 'Organization', sortable: true, sort_key: 'organization', thStyle: { width: '160px' } },
    { key: 'created_at', sortable: true, sort_key: 'created_at', thStyle: { width: '160px' }, isDefaultTable: true },
    { key: 'report.station', label: 'Station ID', sortable: true, sort_key: "station", thStyle: { width: '160px' } },
    { key: 'report.device_class', label: 'Device Class', sortable: true, sort_key: "device_class", thStyle: { width: '160px' } },
    { key: 'report.session.serial', label: 'Serial', sortable: true, sort_key: "serial", thStyle: { width: '160px' } },
    { key: 'report.session.state', label: 'State', sortable: true, sort_key: "state", thStyle: { width: '160px' } }
]

const state = {
    deviceReports: null,
    deviceReport: null,
    count: 0,
    selectedFields: optionalFields,
    filter: null,
    sortBy: null,
    sortDesc: false,
    perPage: config.DEFAULT_PER_PAGE,
    searchQuery: '',
    filterConfig: null
  }

  const mutations = {
    deviceReports (state, deviceReports) {
      state.deviceReports = deviceReports;
    },
    deviceReport (state, deviceReport) {
      state.deviceReport = deviceReport;
    },
    count (state, count) {
      state.count = count;
    },
    selectedFields (state, selectedFields) {
      state.selectedFields = selectedFields;
    },
    filter (state, filter) {
      state.filter = filter;
    },
    sortBy (state, sortBy) {
      state.sortBy = sortBy;
    },
    sortDesc (state, sortDesc) {
      state.sortDesc = sortDesc;
    },
    perPage (state, perPage) {
      state.perPage = perPage;
    },
    searchQuery (state, searchQuery) {
      state.searchQuery = searchQuery;
    },
    filterConfig (state, filterConfig) {
      state.filterConfig = filterConfig;
    },
  }

const getters = {
    deviceReports: () => state.deviceReports,
    deviceReport: () => state.deviceReport,
    count: () => state.count,
    optionalFields: () => optionalFields,
    selectedFields: () => state.selectedFields,
    tableFields: () => {
      return [...requiredFields, ...state.selectedFields];
    },
    filter: () => state.filter,
    sortBy: () => state.sortBy,
    sortDesc: () => state.sortDesc,
    perPage: () => state.perPage,
    searchQuery: () => state.searchQuery,
    filterConfig: () => state.filterConfig,
    fetchParams: (state) => {
      let fetchParams = {};

      if (state.sortBy) {
        let sortField = optionalFields.find(field => {
          return state.sortBy == field.key;
        });
        fetchParams.sort_by = sortField.sort_key || sortField.key;
      }
      fetchParams.sort_desc = state.sortDesc;

      if (state.searchQuery) {
        fetchParams.search = state.searchQuery;
      }
      if (state.filter) {
        fetchParams = { ...fetchParams, ...state.filter };
      }

      return fetchParams;
    }
}

const actions = {
      async fetchDeviceReports({ commit, getters }, params) {
        try {
          let fetchParams = { ...getters.fetchParams };
          Object.keys(params).forEach(key => fetchParams[key] = params[key]);

          const response = await ziperase.fetchDeviceReports(fetchParams);
          commit('deviceReports', response.data.data.map(item => {
            item.isSelected = false;
            return item;
          }));
          commit('count', response.data.pagination.count);
        } catch (err) {
          console.log(err);
          notify().error('Error! Failed to get device reports.');
        }
      },
      async fetchDeviceReport({ commit }, id) {
        try {
          const response = await ziperase.fetchDeviceReport(id);
          commit('deviceReport', response.data);
        } catch (err) {
          console.log(err);
          commit('deviceReport', null);
          notify().error('Error! Failed to get device report.');
        }
      },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
  }
